import { useCallback, useState } from "react";
import { ApiError } from "./api";

export type FormFieldErrors = Record<string, string>;

function focusField(field: string) {
  globalThis.setTimeout(() => {
    const element = document.getElementsByName(field)[0];
    if (element instanceof HTMLElement) element.focus();
  });
}

export function useFormErrors() {
  const [errors, setErrors] = useState<FormFieldErrors>({});

  const capture = useCallback((cause: unknown) => {
    if (!(cause instanceof ApiError) || cause.errors.length === 0) return false;
    const next = cause.fieldErrors;
    if (Object.keys(next).length === 0) return false;
    setErrors(next);
    focusField(Object.keys(next)[0]!);
    return true;
  }, []);

  const clear = useCallback((field?: string) => {
    if (!field) {
      setErrors({});
      return;
    }
    setErrors((current) => {
      if (!current[field]) return current;
      const next = { ...current };
      delete next[field];
      return next;
    });
  }, []);

  return { errors, capture, clear };
}

export function fieldErrorId(field: string) {
  return `field-error-${field.replace(/[^a-z0-9_-]+/gi, "-")}`;
}
